import { render, staticRenderFns } from "./dialog-document-feedback.vue?vue&type=template&id=65fe4f63&scoped=true&"
import script from "./dialog-document-feedback.vue?vue&type=script&lang=js&"
export * from "./dialog-document-feedback.vue?vue&type=script&lang=js&"
import style0 from "./dialog-document-feedback.vue?vue&type=style&index=0&id=65fe4f63&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fe4f63",
  null
  
)

export default component.exports